<template>
  <div class='detail'>
    <back />
    <div class="content">

      <el-descriptions title="基本信息：" :column="1">
        <el-descriptions-item label="项目图片" label-align="center">
          <el-image style="width: 140px; height: 100px; margin-left: 20px;" :src="data.picUrl" fit="cover" @click="previewImage(data.picUrl)"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="标题">{{data.title}}</el-descriptions-item>
        <el-descriptions-item label="正文">
          <div v-html="data.content"></div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="() => { showViewer = false }" :url-list="imgList"></el-image-viewer>
  </div>
</template>

<script>

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      // 图片预览
      showViewer: false,
      imgList: [],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      ],
      data: {}
    }
  },
  created() {
    this.selectNoticeInfoDetail()
  },
  methods: {
    selectNoticeInfoDetail() {
      this.$axios.get(this.$api.selectNoticeInfoDetail, { params: { id: this.$route.query.id } }).then((res) => {
        if (res.code == 100) {
          this.data = res.result
        }
      }).catch(err => {
        this.$message({
          message: err.desc,
          type: 'error'
        })

      })
    },
    // 图片放大
    previewImage(url) {
      // console.log(url);
      this.imgList[0] = url
      this.showViewer = true
    }
  },
}
</script>

<style scoped lang='scss'>
.detail {
  .content {
    margin-top: 30px;
    ::v-deep .el-descriptions-item__container {
      align-items: center;
    }
  }

  .content,
  .leave_msg {
    ::v-deep .el-descriptions__title {
      color: #1a1a1a;
      font-size: 18px;
    }
  }

  .leave_msg {
    ::v-deep .el-descriptions-item__label {
      margin: 0;
    }
  }
}
</style>
